module.exports = __webpack_public_path__ + "static/media/gb-wls.bedb82d0.svg";